<template>
    <div class="battery" :class="statusClass">
        <div class="status">{{ batteryStatus }} {{ battery.no }}</div>
        <div class="battery-id">{{ battery.status === '1' && battery.Isactive === 1 ? battery.battery_percent + '%' :
            battery.no }}</div>
        <div class="circle" :class="statusCircle"></div>
    </div>
    <!-- <div class="battery" :class="statusClass">
        <div class="status">{{ battery.status }}</div>
        <div class="battery-id">{{ battery.id }}</div>
        <div class="circle" :class="statusCircle"></div>
    </div> -->
</template>
<!-- detail.status === '1' ? 'Paid' : 'Unpaid' -->
<script>
export default {
    name: "Battery",
    props: ['battery'],
    computed: {
        statusClass() {
            // if (this.battery.status === "1") {
            //     if (this.battery.battery_percent >= 80) {
            //         return "battrty-ready";
            //     } else {
            //         return "battrty-charging";
            //     }
            // } else {
            //     return "battrty-not-ready";
            // }

            if (this.battery.Isactive === 1) {
                if (this.battery.status === "1") {
                    if (this.battery.battery_percent >= 80) {
                        return "battrty-ready";
                    } else {
                        return "battrty-charging";
                    }
                } else {
                    return "battrty-not-ready";
                }
            } else {
                return "battrty-not-ready";
            }

            // if (this.battery.Isactive === 1) {
            //     if (this.battery.status === "1") {
            //         if (this.battery.battery_percent >= 80) {
            //             return "battrty-ready";
            //         } else {
            //             return "battrty-charging";
            //         }

            //     } else {
            //         return "battrty-not-ready";
            //     }
            // } else {
            //     return "battrty-not-ready";
            // }
        },
        statusCircle() {
            if (this.battery.Isactive === 1) {
                if (this.battery.status === "1") {
                    if (this.battery.battery_percent >= 80) {
                        return "circle-ready";
                    } else {
                        return "circle-charging";
                    }
                } else {
                    return "circle-not-ready";
                }
            } else {
                return "circle-not-ready";
            }
        },
        batteryStatus() {
            if (this.battery.Isactive === 1) {
                if (this.battery.status === "1") {
                    if (this.battery.battery_percent >= 80) {
                        return "BATTERY READY";
                    } else {
                        return "BATTERY CHARGING";
                    }
                } else {
                    return "BATTERY NOT READY";
                }
            } else {
                return "BATTERY NOT READY";
            }
        },
    }
}
</script>
  
<style scoped>
.battery {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 77px;
    flex-direction: column;
    border-radius: 8px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
    color: #fff;
}

.battery-id {
    position: absolute;
    bottom: 13px;
    font-size: 24px;
    font-weight: 700;
}

.status {
    position: absolute;
    top: 10px;
    font-size: 8px;
}

.battrty-ready {
    background-color: #FFAE34;
    cursor: pointer;
}

.battrty-not-ready {
    background-color: var(--light-silver, #F2F2F2);
    color: var(--dark-silver, #C1C1C1);
    ;
}

.battrty-charging {
    background-color: #FFDAA3;
    color: #FE9800;
}

.circle {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 8px;
    height: 8px;
    border-radius: 50px;
}

.circle-ready {
    background: #10EB41;
}

.circle-not-ready {
    background: var(--dark-silver, #C1C1C1);
}

.circle-charging {
    background: linear-gradient(144deg, #FE9900 13.23%, #FFE25E 110.86%);
}
</style>
  